import raven from 'raven-js'
import _ from 'lodash'

export const monitoringFactory = ({ url, viewMode }: { url: string; viewMode: 'site' | 'preview' }) => {
	const sessionData = {
		extra: {
			renderingEnvironment: process.env.browser ? 'browser' : 'backend',
			referrer: null // TODO window.document.referrer
		},
		tags: {
			fullUrl: url,
			viewMode,
			artifactVersion: `thunderbolt-${process.env.APP_VERSION}`
		},
		request: {
			url
		}
	}

	return {
		createMonitor: (dsn: string, dataCallback = _.noop) => {
			// @ts-ignore
			const monitor = new raven.Client()
			monitor.config(dsn, {
				dataCallback: (data: any) => _.merge({}, sessionData, dataCallback(data))
			})
			return monitor
		},
		getSessionData: () => sessionData
	}
}
